import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Trigger from 'formvalidation/es6/plugins/Trigger';
import Recaptcha from 'formvalidation/es6/plugins/Recaptcha';
import AutoFocus from 'formvalidation/es6/plugins/AutoFocus';

(function ready(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(function() {

    var submitForm = document.getElementById('dmca-takedown');

    var plugins = {
        trigger: new Trigger(),
        bootstrap3: new Bootstrap3(),
        defaultSubmit: new DefaultSubmit(),
        submitButton: new SubmitButton(),
        autoFocus: new AutoFocus(),
        declarative: new Declarative({
            html5Input: true
        })
    };
    if (document.getElementById('captcha_container')) {
        plugins['recaptcha'] = new Recaptcha({
            element: 'captcha_container',
            siteKey: '6LcyWRsUAAAAALEi23AyVvcTogjVqGKCAkqZmCbq',
            message: document.getElementById('captcha_container').getAttribute('data-fv-not-empty___message')
        });
    }
    const fv = formValidation(submitForm, {
        plugins: plugins
    });

});

